export const routes_publicaciones = [
  {
    path: '/header',
    component: () => import('./pages/header'),
    children: [
      {
        path: '/',
        name: 'public-index',
        component: () => import('./pages/Index'),
        children: [
          {
            path: '/procesos/publico',
            name: 'list',
            component: () => import('./pages/list')
          },
          {
            path: '/empresas/inhabilitadas',
            name: 'unauthorizedProvider',
            component: () => import('./pages/UnauthorizedProvider')
          },
          {
            path: '/procesos/documentos',
            name: 'processFile',
            component: () => import('./pages/ProcessFiles')
          },
          /*{
              path: '/procesos/lotes/publico',
              name: 'bannedProv',
              component: () => import('./pages/plotsListPublic')
          },
           */
          {
            path: '/procesos/publico/:id',
            name: 'lista tipo',
            component: () => import('./pages/list')
          },
          {
            path: '/procesos/detalle/:id',
            name: 'detalle',
            component: () => import('./pages/detalle')
          }
        ]
      },
      {
        path: '/procesos/resumen/:id',
        name: 'resumen',
        component: () => import('./pages/mantenimiento/resumen')
      }
    ]
  }
]
